import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '../../../atoms/icons';

interface Props {
    title: string;
}

const LandingHeader: React.FC<Props> = (props) => {
  const { title } = props;
  const navigation = useNavigate();

  return (
    <div className="px-4 px-xl-5">
      <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '35px' }}>
        <div className="fw-bold fz-24">{title}</div>
        <button
          type="button"
          className="rounded-circle bg-dark border-0 flexible-center me-2"
          style={{ width: 35, height: 35 }}
          onClick={() => navigation('/user-profile')}
          data-bs-toggle="tooltip"
          title="Edit Profile"
        >
          <User width={23} />
        </button>
      </div>
    </div>
  );
};

export default React.memo(LandingHeader);
